import useMemo from "react";

export const getDeviceName = (element, advancedDeviceIds) => {
  let deviceName;
  if (element.nickname !== undefined && element.nickname !== null){
    if(element.nickname.indexOf('|') !== -1) {
      deviceName = element.nickname.slice(
        element.nickname.indexOf('|') + 1,
        element.nickname.length
      );
    }else{
      deviceName = element.nickname;
    }
  } else if (element.name !== undefined && element.name !== null) {
    deviceName = element.name.indexOf('|') !== -1
      ? element.name.slice(element.name.indexOf('|') + 1)
      : element.name;
  }

  
    if ((deviceName === undefined || deviceName.length === 0) && element.mac) {
      if (advancedDeviceIds && advancedDeviceIds[element.mac] && advancedDeviceIds[element.mac]['advancedDeviceId']) {
        if (advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel']
          && advancedDeviceIds[element.mac]['advancedDeviceId']['modelAccuracyLevel'] > 4) {
          deviceName = advancedDeviceIds[element.mac]['advancedDeviceId']['model'] ? advancedDeviceIds[element.mac]['advancedDeviceId']['model'] : (advancedDeviceIds[element.mac]['advancedDeviceId']['type'] ? advancedDeviceIds[element.mac]['advancedDeviceId']['type'] : '');
        }
      }
    }
    if (deviceName === undefined || deviceName.length === 0) {
      deviceName = element.hostName ? element.hostname : (element.mac ? element.mac : 'Unknown' );
    }
  
    let shortDeviceName = deviceName;
    if (deviceName && deviceName.length > 12) {
      shortDeviceName = deviceName.substring(0, 12) + '...';
    }
    return {deviceName, shortDeviceName};
}

 export const getDeviceIconUrl = (deviceMac, advancedDeviceIds) => {
  if (!deviceMac) {
    return undefined;
  }
  if (!advancedDeviceIds) {
    return undefined;
  }
  let adid = advancedDeviceIds[deviceMac];
  if (!adid) {
    return undefined;
  }
  let icons = adid.deviceIcons.icons;
  return icons['3x'] || icons['2x'] || icons['1x'];
}
export const getDeviceModel = (deviceMac, nameType, advancedDeviceIds) => {
  if (!advancedDeviceIds) {
    return 'N/A';
  }
  let advancedDevice = advancedDeviceIds[deviceMac];
  if (!advancedDevice || !advancedDevice.advancedDeviceId) {
    return 'N/A';
  }
  let model = advancedDevice.advancedDeviceId.model;
  if (!model) {
    return 'N/A';
  }
  if (nameType === 'shortName' && model && model.length > 12) {
    model = model.substring(0, 12) + '...';
  }
  return model;
};

export const getSoftwareVersion = (deviceMac, advancedDeviceIds) => {
  if (!advancedDeviceIds) {
    return 'N/A';
  }
  let advancedDevice = advancedDeviceIds?.[deviceMac];
  if (!advancedDevice || !advancedDevice?.advancedDeviceId) {
    return 'N/A';
  }
  let softwareVersion = advancedDevice?.advancedDeviceId?.operatingSystem;
  if (!softwareVersion) {
    return 'N/A';
  }
  return softwareVersion;
};

export const getDeviceSignalStatus = (element) => {
  let deviceSignalStatus = 'Disconnected';
  let status, freq;
  const colorCode = {
    connected: 'green',
    excellent: 'green',
    disconnected: '#6F777E',
    poor: 'red',
    good: 'green',
    fair: 'red',
    calculating: 'orange',
  };
  if (element?.health?.status) {
    status =
      element.health.status.charAt(0).toUpperCase() +
      element.health.status.slice(1);
  } else {
    status = 'Disconnected';
  }
  if (
    element?.connectionState === 'connected' &&
    element?.freeze.frozen === true
  ) {
    status = 'Paused';
    deviceSignalStatus = 'Paused';
  } else if (
    element?.connectionState === 'connected' &&
    element?.capabilities
  ) {
    deviceSignalStatus = status;
  } else if (
    element?.connectionState === 'connected' &&
    !element?.capabilities
  ) {
    deviceSignalStatus = status;
  }
  if (element.connectionState === 'disconnected') {
    freq = 'N/A';
  } else if (element.medium && element.medium === 'wifi') {
    if (
      element.freqBand &&
      (element.freqBand.includes('5G') || element.freqBand.includes('5g'))
    ) {
      freq = '5GHz';
    } else if (
      element.freqBand &&
      (element.freqBand.includes('2.4G') ||
        element.freqBand.includes('2.4g'))
    ) {
      freq = '2.4GHz';
    } else {
      freq = 'N/A';
    }
  } else if (element.medium && element.medium === 'ethernet') {
    freq = 'Ethernet';
  } else {
    freq = 'N/A';
  }

  let statusColor;
    if (status === 'N/A') {
      statusColor = { color: 'red' };
    } else {
      statusColor = {
        color: element?.health
          ? colorCode[element?.health.status]
          : colorCode.disconnected,
      };
    }

  return { deviceSignalStatus, status, freq, statusColor, colorCode };
};

export const getDevicePauseStatus = (element) => {
  return element?.freeze?.frozen === true ? 'pause' : 'unpaused';
}

/******************* GROUP COMMON FUNCTIONS *****************/

export const isGroupNameExist = (groups, groupName) => {
  let match = groups.filter((g) => g.nickname === groupName);
  return match.length > 0;
};

export const getGroupMap = (groups) => {
  let groupMap = {};
  if (groups.length) {  
    groups.forEach(group => {
      if (!group.devices) return;
      group.devices.forEach(device => {
        groupMap[device.mac] = group;
      });
    });
  }
  return groupMap;
};

export const getGroupName = (deviceGroups, deviceMac) => {
  return  deviceGroups[deviceMac] && deviceGroups[deviceMac].nickname
  ? deviceGroups[deviceMac].nickname
  : '';
}

export const EquipmentTypes = {
  Router : 'router',
  Pod : 'pod',
  Equipment: 'equipment',
  IOT: 'iot'
}

